<template>
  <div class="general-details">
    <div class="general-details-table">
      <table style="width:100%">
        <tbody :key="indextr " v-for="(tr,indextr) in general_details">
        <tr>
          <td width="50px" class="text-dark">Q :</td>
          <td class="text-black">{{ tr.field_name }}</td>
        </tr>
        <tr>
          <td width="50px" class="text-black">A :</td>
          <td
            class="w-full text-dark"
            v-html="tr.answer"
          >{{ tr.answer }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  components: {},
  data() {
    return {
      general_details: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      search: null,
      service: 0,
      services_drop: []
    };
  },
  props: ["consultantId"],
  computed: {},
  mounted() {
    this.getGeneralInformation();
  },
  methods: {
    async getGeneralInformation() {
      let input = {
        consultant_id: this.consultantId
      };
      let response = await this.getHTTPPostResponse(
        "project-consultant-general-information/list/" + this.$route.params.id,
        input
      );
      if (response) {
        let data = response.data;
        let general_details = data.consultant_general_information;
        this.general_details = general_details;
      }
    }
  }
};
</script>
<style scoped>
th {
  border: 1px solid black;
  background: rgba(var(--vs-dark), 1) !important;
  color: #fff !important;
  font-weight: 600;
}
td.text-primary,
td.text-black {
  border-right: none !important;
}
</style>

